/* @flow */
import { ReduceStore } from 'flux/utils';
import { dispatcher } from 'lib/Dispatcher';
import { reducer, initialState } from 'payments/reducers/PaymentAccount';

class PaymentAccountStore extends ReduceStore {
  getInitialState() {
    return initialState;
  }

  getPaymentAccount() {
    return this.getState().paymentAccount;
  }

  reduce(state, action) {
    return reducer(state, action);
  }
}

export default new PaymentAccountStore(dispatcher);



// WEBPACK FOOTER //
// ./src/payments/stores/PaymentAccountStore.js